import React from 'react';

import styled from 'styled-components';

import { desktop, mobile } from '~/techstyle-shared/react-components';

import { useStyleGuideContext } from '../../context/StyleGuideContext';

import FilterPill from './FilterPill';

const FilterPillWrapper = styled.div`
  display: flex;
  flex-direction: row;

  ${desktop`
    padding: 16px 8px;
    gap: 8px;
    justify-content: center;
    align-items: center;
  `}

  ${mobile`
    padding: 8px;
    gap: 8px;
    overflow: auto;
    ::-webkit-scrollbar {
        display: none;
    }
  `}
`;

export default function StyleGuideFilterPills() {
  const { filterValues, tagList } = useStyleGuideContext();
  const showPills = Boolean(filterValues?.length);

  return (
    <>
      {showPills && (
        <FilterPillWrapper>
          {filterValues.map((filterLabel) => (
            <FilterPill
              key={filterLabel}
              filterLabel={filterLabel}
              tagList={tagList}
            />
          ))}
        </FilterPillWrapper>
      )}
    </>
  );
}
